// @flow
import gql from 'graphql-tag'
import { type User, USER_FIELDS_FRAGMENT } from 'gql/user'

export const SCHOOL_WITH_DIRECTOR_FIELDS_FRAGMENT = gql`
  fragment SchoolWithDirectorFields on School {
    director {
      ...UserFields
    }
  }
  ${USER_FIELDS_FRAGMENT}
`

export type SchoolWithDirector = {
  director: User | null,
}
